<template>
  <div id="image-rotator">
    <img :src="paths[pathIndex]" :width="width" />
  </div>
</template>

<script>
export default {
  props: {
    paths: {
      type: Array,
      required: true
    },
    timing: {
      type: Number,
      required: true
    },
    width: {
      type: String
    }
  },
  data () {
    return {
      interval: null,
      pathIndex: -1
    }
  },
  created () {
    this.changeImage()
    if (this.paths.length > 1) {
      this.interval = setInterval(() => {
        this.changeImage()
      }, this.timing)
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.interval = null
  },
  methods: {
    changeImage () {
      this.pathIndex++
      if (this.pathIndex >= this.paths.length) this.pathIndex = 0
    }
  }
}
</script>

<style lang="scss">
</style>
